import { Header } from './AppBar.styled';
import { Navigation } from 'components/Navigation/Navigation';

export const AppBar = () => {
  return (
    <Header>
      <Navigation />
    </Header>
  );
};
